import Cookies from "js-cookie"
import { safeDecode } from "../common/decoder"

function getHeadersformdata () {
    return {
      'Content-Type': 'multipart/form-data',
      "accept": "application/json",
      'Authorization': safeDecode(Cookies.get('accessToken')) ? `${safeDecode(Cookies.get("accessToken"))}` : null,
      'Access-Control-Allow-Origin': '*'
    }
  }
  export default getHeadersformdata